import { type FC } from "react";
import ModuleConfigurationSection from "./components/ModuleConfigurationSection";
import ModuleLayoutSection from "./components/ModuleLayoutSection";

const ContentBlocksSection: FC = () => {
  return (
    <>
      <ModuleLayoutSection />
      <ModuleConfigurationSection />
    </>
  );
};

export default ContentBlocksSection;
